import { DefaultTheme } from 'styled-components';

interface GetColorFromProps {
  theme: DefaultTheme;
  isActive: boolean;
  isDisabled: boolean;
  isErrored: boolean;
}

export const getColorFromProps = ({
  theme,
}: GetColorFromProps) => {
  return theme.newUI.defaultColors.text;
};
